import { z } from 'zod';

import { isValidPhone } from '@/lib/phone';
import { CanalEnvio, TipoProfesional } from '@/types/enums';

const emailListSchema = z
  .array(z.string().email({ message: 'Email inválido' }))
  .max(10, 'Máximo 10 emails');

export const profesionalFormSchema = z
  .object({
    nombre_apellido: z
      .string()
      .trim()
      .min(1, 'Ingresá el nombre y apellido')
      .max(200, 'Máximo 200 caracteres'),
    tipo_profesional: z.nativeEnum(TipoProfesional),
    tipo_profesional_otro: z.string().trim().max(100).optional().or(z.literal('')),
    telefono_whatsapp: z.string().trim().optional().or(z.literal('')),
    emails: emailListSchema,
    localidad: z.string().trim().max(100).optional().or(z.literal('')),
    envio_informe: z.nativeEnum(CanalEnvio),
  })
  .refine(
    (data) =>
      data.tipo_profesional !== TipoProfesional.OTRO ||
      (data.tipo_profesional_otro && data.tipo_profesional_otro.trim().length > 0),
    {
      message: 'Especificá el tipo profesional',
      path: ['tipo_profesional_otro'],
    }
  )
  .refine(
    (data) => data.envio_informe !== CanalEnvio.EMAIL || data.emails.length > 0,
    {
      message: 'Si el envío es por email, agregá al menos uno',
      path: ['emails'],
    }
  )
  .refine(
    (data) =>
      data.envio_informe !== CanalEnvio.WHATSAPP ||
      (data.telefono_whatsapp && data.telefono_whatsapp.trim().length > 0),
    {
      message: 'Si el envío es por WhatsApp, ingresá el teléfono',
      path: ['telefono_whatsapp'],
    }
  )
  .refine(
    (data) => !data.telefono_whatsapp || isValidPhone(data.telefono_whatsapp),
    {
      message: 'Número inválido. Usá formato internacional.',
      path: ['telefono_whatsapp'],
    }
  );

export type ProfesionalFormValues = z.infer<typeof profesionalFormSchema>;
